import { getArticleUrl } from '@/client/services/url/faq'

import ShwLink from '@/components/ShwLink'

export default function AgeAssurancePolicyNotice() {
  return (
    <>
      Schoolhouse cares about your safety! Before new users can join live sessions, we ask them to
      verify their age. You can learn more about the policy{' '}
      <ShwLink href={getArticleUrl('age-verification-for-new-users')}>here</ShwLink>.
    </>
  )
}
